// Vendor imports
const React = require('react')
const countryCodes = require('country-codes-list')

function IntoLandingSMSModal(props) {
  const callingCodes = countryCodes.customList('countryCallingCode')
  const { assets, isBlurred, dismissOnOuterClick, onDismiss, isSubmitFailed, isSubmitSuccessful, onSendSMS } = props
  const [ phoneNumber, setPhoneNumber ] = React.useState('')
  const onPhoneNumberChange = React.useCallback(
    event => {
      setPhoneNumber(event.target.value)
    },
    [ setPhoneNumber ]
  )
  const onSubmit = React.useCallback(
    event => {
      const callingCode = document.getElementById('country-code').value
      event.preventDefault()
      onSendSMS(`${callingCode}${phoneNumber}`)
      setPhoneNumber('')
    },
    [ onSendSMS, phoneNumber, setPhoneNumber ]
  )
  return (
    <div className='sms-wrapper' style={ isBlurred ? { zIndex: '1' } : { zIndex: '0' } } onClick={ dismissOnOuterClick ? onDismiss : null }>
      <div className={`download-modal relative px-6 pt-24 items-center ${isBlurred ? 'section-visible' : 'section-hidden'}`}>
        <div className="relative">
          <div className="relative z-10 -mt-24" onClick={e => e.stopPropagation()} >
            <div className="flex flex-col md:flex-row relative mb-6">
              <div className="w-64 inline-block bg-white rounded-t-xl md:rounded-tr-none md:rounded-l-xl p-4 pb-5 md:p-6 text-black text-center">
                <img className="mx-auto w-full aspect-square mb-2" src={assets['qr_download']} alt="Download app" />
                <span className="block font-medium text-lg">Scan to install</span>
              </div>
              <div className="w-64 bg-white bg-opacity-10 rounded-b-xl md:rounded-l-none md:rounded-r-xl p-6 text-center flex flex-col items-center justify-center">
                <div className="mt-2 mb-7">
                  {isSubmitSuccessful && <div className="mt-12 mb-14"><p className="text-lg">SMS Sent!</p> <p className="opacity-50">Check your phone.</p></div>}
                  {isSubmitFailed && <div className="mt-12 mb-14"><p className="text-lg">Sorry, we could not send the SMS.</p> <p className="opacity-50">Please contact support@mix.com.</p></div>}
                  {!isSubmitSuccessful && !isSubmitFailed && <React.Fragment><p className="leading-tight mb-4">Get a text message to download the app</p>
                    <form>
                      <div className="w-full max-w-full in-foreground">
                        <div className="btn w-full mb-2 p-0 flex focus-within:outline-orange-500">
                          <select id="country-code" className="appearance-none p-3 pl-4 pr-0 bg-transparent text-white focus:outline-none relative top-px">
                            {Object.keys(callingCodes).map(code =>
                              <option key={code} value={`+${code}`}>+{code}</option>
                            )}
                          </select>
                          <input className="w-40 p-3 bg-transparent focus:outline-none relative top-px" type="text" placeholder="(555) 123-4567" value={phoneNumber} onChange={onPhoneNumberChange} />
                        </div>
                      </div>
                      <button className="btn btn-secondary w-full" disabled={!phoneNumber} onClick={onSubmit}>Send SMS</button>
                    </form>
                  </React.Fragment>}
                </div>
                <div className="flex space-x-4">
                  <a href="https://apps.apple.com/pt/app/mix-rediscover-the-internet/id1092817691" target="_blank" className="btn btn-square" rel="external nofollow noopener noreferrer">
                    <svg fill="currentColor" className="aspect-square w-4" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <title>Apple</title>
                      <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"></path>
                    </svg>
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.mix.android" target="_blank" className="btn btn-square" rel="external nofollow noopener noreferrer">
                    <svg fill="currentColor" className="aspect-square w-4" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <title>Android</title>
                      <path d="M17.523 15.3414c-.5511 0-.9993-.4486-.9993-.9997s.4483-.9993.9993-.9993c.5511 0 .9993.4483.9993.9993.0001.5511-.4482.9997-.9993.9997m-11.046 0c-.5511 0-.9993-.4486-.9993-.9997s.4482-.9993.9993-.9993c.5511 0 .9993.4483.9993.9993 0 .5511-.4483.9997-.9993.9997m11.4045-6.02l1.9973-3.4592a.416.416 0 00-.1521-.5676.416.416 0 00-.5676.1521l-2.0223 3.503C15.5902 8.2439 13.8533 7.8508 12 7.8508s-3.5902.3931-5.1367 1.0989L4.841 5.4467a.4161.4161 0 00-.5677-.1521.4157.4157 0 00-.1521.5676l1.9973 3.4592C2.6889 11.1867.3432 14.6589 0 18.761h24c-.3435-4.1021-2.6892-7.5743-6.1185-9.4396"></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div className="text-center">
              <button className="btn" onClick={onDismiss}>Done</button>
            </div>
          </div>
          <span className="absolute top-0 inset-x-0 h-24 bg-black blur-2xl"></span>
          <span className="absolute inset-0 bg-black blur-2xl opacity-50"></span>
        </div>
      </div>
    </div>
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  IntoLandingSMSModal.propTypes = {
    assets: PropTypes.object,
    isBlurred: PropTypes.bool,
    dismissOnOuterClick: PropTypes.bool,
    onDismiss: PropTypes.func,
    onSendSMS: PropTypes.func,
    isSubmitFailed: PropTypes.bool,
    isSubmitSuccessful: PropTypes.bool
  }
}

module.exports = IntoLandingSMSModal
